// Shared intake schema + stubbed integration methods.
// These are used by both the proposal form and the representative path
// so they share the same conceptual lead model.

export const IGNITE_CONSULT_URL =
    "https://calendly.com/d/cx6y-kt3-qzb/ignite-health?utm_source=BRIA&utm_medium=calendly&utm_campaign=pcmp&utm_content=RR&month=2026-09";

export const PAPERFORM_URL = "https://ywbjco9t.paperform.co/";

export const SHORT_FORM_VIDEO_URL =
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_hire-connect-ignite/artifacts/7gemftb7_Ignite%20Plan%20Overview_Short%20Form%20%281%29.mp4";

export const PLATFORM_DEMO_VIDEO_URL =
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_hire-connect-ignite/artifacts/cjz1upiy_Ignite%20Promo%20v2.1%20%281%29.mp4";

export const INDUSTRIES = [
    { key: "church", label: "Churches & faith organizations" },
    { key: "home_health", label: "Home health agencies" },
    { key: "senior_care", label: "Senior care agencies" },
    { key: "security", label: "Security agencies" },
    { key: "restaurant", label: "Restaurant groups" },
    { key: "hospitality", label: "Hospitality groups" },
    { key: "cannabis", label: "Cannabis dispensaries" },
    { key: "other", label: "Other employer" },
];

export const PAYROLL_RANGES = [
    "Under $1M",
    "$1M – $3M",
    "$3M – $7M",
    "$7M – $15M",
    "$15M+",
    "Not sure yet",
];

export const BENEFITS_STATUS = [
    { value: "none", label: "No current benefits" },
    { value: "limited", label: "Limited benefits" },
    { value: "existing", label: "Existing plan in place" },
    { value: "not_sure", label: "Not sure" },
];

export const MAIN_GOALS = [
    { value: "retention", label: "Improve retention" },
    { value: "recruiting", label: "Support recruiting" },
    { value: "explore_options", label: "Explore benefit options" },
    { value: "manage_costs", label: "Manage costs" },
    { value: "employee_support", label: "Improve employee support" },
];

export const NEXT_STEPS = [
    { value: "proposal_first", label: "Proposal first" },
    { value: "talk_to_representative", label: "Talk to a representative" },
    { value: "book_with_ignite", label: "Book directly with Ignite Health" },
];

export const emptyLead = () => ({
    kind: "proposal",
    organizationName: "",
    contactName: "",
    contactEmail: "",
    phone: "",
    industry: "",
    states: [],
    employeeCount: "",
    payrollRange: "",
    workforceMix: "",
    benefitsStatus: "",
    mainGoal: "",
    preferredNextStep: "",
    contactPath: "form",
    sourcePage: typeof window !== "undefined" ? window.location.pathname : "",
    notes: "",
    campaign: "The HR Connect x Ignite Health",
});

// Stub integration helpers (frontend mirror).
// In production, these route through the backend, but they are exposed
// here for the conceptual schema and a dev/debug panel.
export const createIntroEmailPayload = (lead) => ({
    to: "intros@ignitehealth.example",
    subject: `[The HR Connect] Intro: ${lead.organizationName || "New employer"}`,
    lead,
});
export const sendToWebhook = (lead) => ({ queued: true, lead });
export const saveLeadToCRM = (lead) => ({ crm: "folk", synced: true, lead });
export const bookConsult = (lead) => ({
    calendly_url: IGNITE_CONSULT_URL,
    prefill: lead.contactEmail,
});
export const createRepresentativeNotes = (lead) => ({
    summary: `Rep intake — ${lead.organizationName || "unknown org"} (${lead.employeeCount || "?"} employees)`,
    next_step: lead.preferredNextStep || "talk_to_representative",
});
